import { BillRepository } from "../../repositories/BillRepository";
import {
  ManualBillCreatedEntity,
  BillDataEntity,
} from "../../entities/BillEntity";

/**
 * Create Manual Bill Use Case
 * Creates a bill from form data (and optional attachments) and pushes to Zoho.
 */
export class CreateManualBillUseCase {
  constructor(private repository: BillRepository) {}

  async execute(
    billData: BillDataEntity,
    companyGstEnabled: number,
    attachments?: File[]
  ): Promise<ManualBillCreatedEntity> {
    return this.repository.createManualBill(
      billData,
      companyGstEnabled,
      attachments
    );
  }
}
